"use strict";
/*
 * Created by Ivan Sanz (@isc30)
 * Copyright © 2017 Ivan Sanz Carasa. All rights reserved.
*/
Object.defineProperty(exports, "__esModule", { value: true });
function combineComparers(left, right) {
    return function (l, r) { return left(l, r) || right(l, r); };
}
exports.combineComparers = combineComparers;
function createComparer(keySelector, ascending, customComparer) {
    if (customComparer !== undefined) {
        return function (l, r) { return customComparer(keySelector(l), keySelector(r)); };
    }
    return ascending
        ? function (l, r) {
            var left = keySelector(l);
            var right = keySelector(r);
            return left < right
                ? -1
                : left > right
                    ? 1
                    : 0;
        }
        : function (l, r) {
            var left = keySelector(l);
            var right = keySelector(r);
            return left < right
                ? 1
                : left > right
                    ? -1
                    : 0;
        };
}
exports.createComparer = createComparer;
//# sourceMappingURL=Comparers.js.map